import { Popover } from "antd";
import React, { useEffect, useState } from "react"
import { AppTranslateAIPopupChat } from "./AppTranslateAIPopup";
import { IconTranslate } from "./newIcons";



export const AppAiChatTranslateWin: React.FC<{
  textValue: string | undefined | null;
  translateResult: (translatedText: string) => void;
}> = React.memo(({ textValue, translateResult }) => {

  const [open, setOpen] = useState(false);

  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };


  return (
    <Popover
      content={
        <div>
          <AppTranslateAIPopupChat
            textValue={textValue}
            translateResult={(translatedText) => {
              hide();
              translateResult(translatedText);
            }}
          /></div>}
      trigger="click"
      placement="right"
      arrow={false}
      onOpenChange={handleOpenChange}
      open={open}
      getPopupContainer={(triggerNode) => triggerNode
      }>
      <a
        href={undefined}
        style={{ cursor: 'pointer', textDecoration: 'none', paddingTop: "3px" }}
      >
        {IconTranslate}
      </a>
    </Popover>
  );
});
